// extracted by mini-css-extract-plugin
export default {"dropdown":"DropdownMenu_dropdown__7uVQ9","dropdown_menu":"DropdownMenu_dropdown_menu__CmcUf","dropdown_backdrop":"DropdownMenu_dropdown_backdrop__ykXF+"};